import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button, OverlayTrigger, Popover } from "react-bootstrap";
import { MdOutlineHelp } from "react-icons/md";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import studentServices from "../../../services/student.services";
import { authServices } from "../../../services/auth.services";
import { Autocomplete } from "@mui/material";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import LoadingBar from "../toaster/loader/loader";
import { showErrorMessage, showSuccessMessage } from "../../../services/utils";
import StudentDocView from "./studentDocsView";
import { toast } from "react-toastify";
const popover = (
    <Popover id="popover-basic" className="info_pop">
        <Popover.Body>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus
            dolor aperiam.
        </Popover.Body>
    </Popover>
);

const StudenInfofirst = (props) => {
    const [modalOpen, setModalOpen] = useState(false)
    const navigate = useNavigate()
    const [Fieldval, SetFieldVal] = useState({
        prior_certifications_proof: [],
        school_name: "",
        program_id: ""
    })

    const [schoolList, setSchoolList] = useState([])
    const [programs, setPrograms] = useState([])
    const [loading, setload] = useState(false)
    const [submit, setSubmit] = useState(false)
    const [email, setEmail] = useState(false)
    const [email1, setEmail1] = useState(false)

    const handleFieldValue = (e) => {

        const name = e.target.name
        const value = e.target.value

        SetFieldVal({
            ...Fieldval,
            [name]: value
        })
    }

    const updateMyBio = (e) => {
        setload(!loading)
        if (!Fieldval.program_id) {

            showErrorMessage({ message: "Please Select a Program" })
            setload(false)
        } else if (email && email1) {
            studentServices.UpdateStudentData(Fieldval)
                .then(resp => {
                    setload(false)
                    if (props.type === "Edit") {
                        showSuccessMessage({ message: "Profile Updated" })
                    } else {
                        navigate('/student-info2')
                    }
                })
                .catch(err => setload(false))
        }


        e.preventDefault()
    }

    useEffect(() => {

        async function getStudentProfile() {
            setload(true)
            await studentServices.getStudentProfile().then((resp) => {
                SetFieldVal(prev => ({ ...prev, ...resp.data.data.studentinfo }))
                SetFieldVal(prev => ({ ...prev, ...resp.data.data.school }))
                setload(false)
            }).catch(err => setload(false))
        }
        getStudentProfile()

    }, [])

    useEffect(() => {

        studentServices.getSchoolList(Fieldval.school_name)

            .then(resp => {
                resp.data.map((curr, index) => (
                    setSchoolList(prevState => ([...prevState,
                    { school_id: curr._id, country: curr.country, label: curr.school_name, key: curr._id }]))
                )
                )
            })

            .catch(err => console.log(err))


        const getSchoolPrograms = () => {

            authServices.getSchoolPro().then(resp => {
                setPrograms(resp.data)
            }).catch(err => { console.log(err) })
        }

        getSchoolPrograms()

    }, [])

    const handleDocUpload = (e) => {
        setload(!loading)
        const name = e.target.name
        const file = e.target.files[0];

        const obj = {
            document: file,
            doc_type: 'prior_certificate_front'
        };

        const form_data = new FormData();
        for (var key in obj) {
            form_data.append(key, obj[key]);
        }

        studentServices.uploadStudentDoc(form_data)

            .then(resp => {

                setload(false)
                Fieldval[name].push({ file: resp.data, date: new Date })
            })
            .catch(err => setload(false))

    }
    const modalToggle = () => {
        setModalOpen(!modalOpen)
    }
    return (
        <div className="dbbsc_info">
            {loading &&
                <LoadingBar />
            }
            <Form className="signform_div" onSubmit={(e) => {
                updateMyBio(e)

            }}>
                <Row>
                    <Col sm={4} className="mb-3">
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                            name="first_name"
                            value={Fieldval.first_name && Fieldval.first_name}
                            onChange={(e) => { handleFieldValue(e) }}
                            type="text"
                            placeholder="Enter Student Name"
                            required
                        />
                    </Col>
                    <Col sm={4} className="mb-3">
                        <Form.Label>Middle Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={Fieldval.middlename && Fieldval.middlename}
                            placeholder="Enter Middle Name"
                            name="middlename"
                            onChange={(e) => { handleFieldValue(e) }}

                        />
                    </Col>
                    <Col sm={4} className="mb-3">
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={Fieldval.last_name && Fieldval.last_name}
                            placeholder="Enter Last Name"
                            name="last_name"
                            onChange={(e) => { handleFieldValue(e) }}
                            required
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} className="mb-3">
                        <Form.Group
                            className="mb-3 mui_fldchng"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label>School Name</Form.Label>
                            <Autocomplete
                                disablePortal
                                inputValue={Fieldval.school_name && Fieldval.school_name}
                                id="controllable-states-demo"
                                options={schoolList}
                                value={Fieldval?.school_name ? Fieldval.school_name : null}
                                name="school_name"
                                placeholder="Select School Name"
                                onChange={(e, newInputValue, reason, details) => {
                                    if (details?.option.label && details?.option.school_id) {
                                        SetFieldVal({
                                            ...Fieldval,
                                            "school_name": details.option.label,
                                            "school_id": details.option.school_id,
                                        })
                                    }
                                    else {
                                        SetFieldVal({
                                            ...Fieldval,
                                            "school_name": '',
                                            "school_id": '',
                                        })
                                    }
                                }
                                }
                                renderOption={(props, option) => {
                                    return (
                                        <li {...props} value={option.label} key={option.key + new Date().getTime()}>
                                            {option.label + " " + `(${option.country})`}
                                        </li>
                                    );
                                }}
                                renderInput={(params) => <TextField {...params}
                                    name="school_name"
                                    onChange={(e) => {
                                        handleFieldValue(e)
                                    }}
                                    label="Search For School"
                                    required
                                />}
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={6} className="mb-3">
                        <Form.Label>Program</Form.Label>
                        <Form.Select aria-label="Default select example"
                            name="program_id"
                            value={Fieldval.program_id && Fieldval.program_id}
                            onChange={(e) => {
                                handleFieldValue(e)
                                e.target.value === '63a4523000a7f8674747c9f9' && setModalOpen(true)
                            }}
                            required
                        >
                            <option>Select Program</option>
                            {programs.map(curr => {
                                return (
                                    <option key={curr._id} value={curr._id}>{curr.program_name}</option>
                                )
                            })}
                        </Form.Select>
                    </Col>
                    <Col sm={6} className="mb-3">
                        <Form.Group
                            controlId="formFile"
                            className=" mui_dtpickr"
                        >

                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <Form.Label>
                                    Program Start Date
                                </Form.Label>

                                <DatePicker
                                    value={Fieldval?.program_start_date ? Fieldval.program_start_date : null}
                                    placeholder="Enter Graduation Date"
                                    className="form-control"
                                    onChange={(
                                        newValue
                                    ) => {
                                        SetFieldVal({
                                            ...Fieldval,
                                            "program_start_date": newValue._d
                                        })
                                    }}
                                    renderInput={(
                                        params
                                    ) => (
                                        <TextField
                                            {...params}
                                            required
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Form.Group>
                    </Col>
                    <Col sm={6} className="mb-3">
                        <Form.Group
                            controlId="formFile"
                            className=" mui_dtpickr"
                        >

                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <Form.Label>
                                    Graduation Date
                                </Form.Label>

                                <DatePicker
                                    value={Fieldval?.graduation_date ? Fieldval.graduation_date : null}
                                    placeholder="Enter Graduation Date"
                                    className="form-control"
                                    onChange={(
                                        newValue
                                    ) => {
                                        SetFieldVal({
                                            ...Fieldval,
                                            "graduation_date": newValue._d
                                        })
                                    }}
                                    renderInput={(
                                        params
                                    ) => (
                                        <TextField
                                            {...params}
                                            required
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col sm={6} className="mb-3">
                        <Form.Label>
                            Professional Email address
                        </Form.Label>
                        <Form.Control
                            type="email"
                            value={Fieldval.professional_email_address && Fieldval.professional_email_address}
                            placeholder="Enter Email address"
                            name="professional_email_address"
                            onChange={(e) => {
                                handleFieldValue(e)
                                if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(Fieldval?.professional_email_address) && Fieldval.professional_email_address !== "") {
                                    setEmail(true)
                                }
                                else {
                                    setEmail(false)
                                }
                            }}
                            required
                        />
                        {submit && !email &&
                            <h8 style={{ "color": "red" }}>Invalid Email</h8>
                        }
                    </Col>
                    <Col sm={6}>
                        <Form.Label>
                            Personal Email address
                        </Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter Personal Email address"
                            value={Fieldval.personal_email_address && Fieldval.personal_email_address}
                            name="personal_email_address"
                            onChange={(e) => {
                                handleFieldValue(e)
                                if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(Fieldval?.personal_email_address) && Fieldval.personal_email_address !== "") {
                                    setEmail1(true)
                                }
                                else {
                                    setEmail1(false)
                                }
                            }}
                            required
                            pattern={/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(Fieldval.personal_email_address) && Fieldval.personal_email_address !== ""}
                        />
                        {submit && !email1 &&
                            <h8 style={{ "color": "red" }}>Invalid Email</h8>
                        }
                    </Col>
                </Row>

                <Row>
                    <Col sm={6} className="mb-3">
                        <Form.Label>
                            Phone Number
                        </Form.Label>
                        <Form.Control
                            type="number"
                            value={Fieldval.phone_number && Fieldval.phone_number}
                            placeholder="Enter Phone Number"
                            name="phone_number"
                            onChange={(e) => { handleFieldValue(e) }}
                            required
                        />
                    </Col>
                    <Col sm={6} className="mb-3">
                        <Form.Group
                            controlId="formFile"
                            className=" mui_dtpickr"
                        >
                            <LocalizationProvider
                                dateAdapter={AdapterMoment}
                            >
                                <Form.Label>
                                    Date of Birth
                                </Form.Label>
                                <DatePicker
                                    value={Fieldval?.dob ? Fieldval.dob : null}
                                    placeholder="Enter Date of Birth"
                                    className="form-control"
                                    onChange={(
                                        newValue

                                    ) => {
                                        SetFieldVal({
                                            ...Fieldval,
                                            "dob": newValue._d
                                        })
                                    }}
                                    renderInput={(
                                        params
                                    ) => (
                                        <TextField
                                            {...params}
                                            required
                                        />
                                    )}
                                    maxDate={new Date()}
                                />
                            </LocalizationProvider>
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                >
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={Fieldval.address && Fieldval.address}
                        name="address"
                        onChange={(e) => { handleFieldValue(e) }}
                        required
                    />
                </Form.Group>

                <Form.Group
                    className="mb-3"
                    controlId="formBasicEmail"
                >
                    <Form.Label>
                        Prior Certifications{" "}
                        <OverlayTrigger
                            trigger="click"
                            placement="right"
                            overlay={popover}
                        >
                            <span className="info_icn">
                                <MdOutlineHelp />
                            </span>
                        </OverlayTrigger>
                    </Form.Label>
                    <Form.Select aria-label="Default select example"
                        name="program_id"
                        value={Fieldval?.prior_certifications}
                        onChange={(e) => {
                            handleFieldValue(e)
                        }}
                        required
                    >
                        <option value="">Select Program</option>
                        <option key={`RN`} value={`RN`} >RN</option>
                        <option key={`LVN`} value={`LVN`} >LVN</option>
                        <option key={`CNA`} value={`CNA`} >CNA</option>
                    </Form.Select>
                    {/* <Form.Control
                        value={Fieldval.prior_certifications && Fieldval.prior_certifications}
                        type="text"
                        placeholder="Enter Prior Certifications (i.e. RN, LVN, CNA)"
                        name="prior_certifications"
                        onChange={(e) => { handleFieldValue(e) }}
                        required
                    /> */}
                </Form.Group>
                <Form.Group
                    controlId="formFile"
                    className="mb-3"
                >
                    <Form.Label>
                        Picture of the front ID
                    </Form.Label>
                    {Fieldval.prior_certifications_proof.length > 0 &&
                        <StudentDocView MapData={Fieldval.prior_certifications_proof} type='prior_certificate_front' />
                    }
                    <Form.Control name='prior_certifications_proof' type="file" onChange={(e) => { handleDocUpload(e) }}
                        required={Fieldval.prior_certifications_proof.length === 0 && true}
                    />

                </Form.Group>
                <div className="text-center">
                    <Button
                        className="btn_theme mt-4"
                        type="submit"
                        onClick={() => setSubmit(true)}
                    >
                        {props.Button}
                    </Button>
                </div>

            </Form>

            <Modal show={modalOpen} onHide={modalToggle} className="main_modl">
                <Modal.Header closeButton>
                    <Modal.Title className="text_theme">
                        Program Information
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="prfl_flds">
                        <Form>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label>Program's Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="other_program_info"
                                    value={Fieldval.other_program_info && Fieldval.other_program_info}
                                    placeholder="Enter Program's Name"
                                    onChange={(e) => { handleFieldValue(e) }}
                                />
                            </Form.Group>

                            <Form.Group
                                controlId="formFile"
                                className="mb-3 mui_dtpickr"
                            >

                            </Form.Group>
                            <div className="text-center">
                                <Button
                                    className="btn_theme mt-4"
                                    variant=""
                                    onClick={() => { modalToggle() }}
                                >
                                    Save
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </div >
    )
}

export default StudenInfofirst